import type { FC } from "react";

import { Container } from "@jti/core-components/components/Container";

import DiscountBlock from "./discount-block/DiscountBlock";

import type { discountInputs } from "./Discount.builder";

type DiscountBuilderProps = BuilderComponentProps<typeof discountInputs>;

export const Discount: FC<DiscountBuilderProps> = (props) => {
  return (
    <Container>
      <DiscountBlock {...props} />
    </Container>
  );
};
